/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Custom_ChooseInputs */



/**
* | output |
* | --- |
* | "Choose from the list" |
*
* @param {Spaces_Modular_Wizard_Custom_ChooseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_custom_choose = /** @type {((inputs?: Spaces_Modular_Wizard_Custom_ChooseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Custom_ChooseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aus der Liste wählen")
	return /** @type {LocalizedString} */ ("Choose from the list")
});